import { useMutation } from 'react-query';
import { Lists } from '~/api/scheme';
import { useForm } from 'react-hook-form';
import { UpdateParams } from '~/api/scheme/lists';
import { useEffect } from 'react';
import useWarnings from '@hooks/useWarnings';
import useListDialogs from '~/hooks/useListDialogs';

const useEditListDialog = () => {
  const { changeWarningsState } = useWarnings();

  const {
    editListOpened: open,
    closeEditListDialog: onClose,
    onClickBack,
    leavePageOpened: isOpenLeavePage,
    onCancel,
    onClickLeaveAnyway,
    editableList: list,
    onEditListSuccessCallback,
    creatableListType,
  } = useListDialogs();

  const mutation = useMutation((params: UpdateParams) => Lists.update(params), {
    onSuccess({ data: { sync_success } }) {
      if (!sync_success && sync_success !== null) {
        changeWarningsState('syncList', true);
      }
      onEditListSuccessCallback?.();
    },
    onError() {
      changeWarningsState('syncList', true);
    },
  });

  const defaultValues = {
    color: list?.attributes.color,
    name: list?.attributes.name,
    description: list?.attributes.description,
    synced: list?.attributes.synced,
    public: list?.attributes.public,
  };

  const methods = useForm<any>({ defaultValues });
  const { reset } = methods;

  useEffect(() => {
    reset({
      color: list?.attributes.color,
      name: list?.attributes.name,
      description: list?.attributes.description,
      synced: list?.attributes.synced,
      public: list?.attributes.public,
    });
  }, [reset, list]);

  const onSubmit = () => {
    mutation.mutate({
      id: String(list?.id),
      type: creatableListType,
      attributes: methods.getValues(),
    });
  };

  const onReset = () => {
    reset(defaultValues);
  };

  return {
    open,
    onClose,
    onClickBack,
    isOpenLeavePage,
    onCancel,
    onClickLeaveAnyway,
    onSubmit,
    onReset,
    methods,
    creatableListType,
    dialogTitle: 'edit_list',
    submitButtonTitle: 'save',
  };
};

export default useEditListDialog;
